/* eslint-disable better-mutation/no-mutation */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { DraftSlice } from './draft';

type EditState = {
    draftBeforeChange: DraftSlice | null;
};

const initialState: EditState = {
    draftBeforeChange: null,
};

const editSlice = createSlice({
    name: 'edit',
    initialState,
    reducers: {
        setDraftBeforeChange: (state, action: PayloadAction<DraftSlice>) => {
            state.draftBeforeChange = action.payload;
        },
    },
});

export const { setDraftBeforeChange } = editSlice.actions;

export default editSlice.reducer;
